import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {

  @Input() dataObj: any;
  @Input() field: string;
  @Output() onUpload = new EventEmitter<any>();
  isUploading: boolean = false;

  constructor(
    private util: UtilService
  ) { }

  ngOnInit(): void {
  }

  uploadDoc(fileInput) {
    const vm = this;
    vm.isUploading = true;
    vm.util.readDoc(fileInput, res => {
      if (res) {
        vm.util.uploadDocAPICall(res, cb => {
          vm.isUploading = false;
          if (cb) {
            vm.dataObj[vm.field] = cb;
            vm.onUpload.emit(vm.field);
          } else {
            vm.util.error('Unable to upload document, please try again');
          }
        });
      } else {
        vm.isUploading = false;
        vm.util.error('Unable to capture document, please try again');
      }
    });
  }

}
